import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "children", "textContent", "$css"];
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { VisuallyHidden } from '@figure/frontlib-accessibility';
import LinkOrButton from '../../LinkOrButton';
import { focus, focusStyles, positionAbsolute } from '../../../styling';
import StyledContainer from '../../Styled/StyledContainer';
var Wrapper = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "DynamicContentTooltip__Wrapper",
  componentId: "sc-1uuok0q-0"
})(["position:relative;z-index:1;"]);
var TooltipButton = /*#__PURE__*/styled(LinkOrButton).withConfig({
  displayName: "DynamicContentTooltip__TooltipButton",
  componentId: "sc-1uuok0q-1"
})(["width:100%;", " ", ""], positionAbsolute(), focus(css(["svg{", ";}"], focusStyles)));
var Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "DynamicContentTooltip__Content",
  componentId: "sc-1uuok0q-2"
})(["pointer-events:none;", ""], positionAbsolute());

var DynamicContentTooltip = function DynamicContentTooltip(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      textContent = _ref.textContent,
      $css = _ref.$css,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "dynamic-tooltip",
    $css: $css
  }, /*#__PURE__*/React.createElement(TooltipButton, _extends({
    type: "button",
    onClick: function onClick() {
      return setVisible(function (visible) {
        return !visible;
      });
    },
    visuallyHiddenText: textContent
  }, rest), icon), /*#__PURE__*/React.createElement(Content, {
    "aria-hidden": "true"
  }, children({
    visible: visible
  })), /*#__PURE__*/React.createElement(VisuallyHidden, {
    "aria-live": "polite"
  }, visible && textContent));
};

export default DynamicContentTooltip;